module.exports = __webpack_public_path__ + "img/newspic.c8f36229.png";